import React from 'react'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Paper from 'material-ui/Paper'

import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { TextField } from 'material-ui';
import { InputAdornment } from 'material-ui/Input';

class SearchBar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      searchTerm: '',
      searching: false
    }
  }

  onChange(e) {
    this.setState({
      searchTerm: e.target.value
    })
    window.clearTimeout(this.inputtimer)
    this.inputtimer = window.setTimeout(() => {
      this.doSearch();
    }, 500)
  }

  doSearch = () => {
    const { pager } = this.props
    const { searchTerm } = this.state
    this.setState({ searching: true })
    pager.pageno = 1
    this.props.search(searchTerm, pager)
  }

  clearSearch = () => {
    const { pager } = this.props
    this.setState({
      searchTerm: '',
      searching: false
    })
    this.props.search('', pager)
  }

  render() {

    const {
      classes,
      translate
    } = this.props

    const {
      searching
    } = this.state

    return (
      <Paper className={classes.root} elevation={1}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <Typography className={classes.flex} color="inherit">
              <TextField
                fullWidth
                value={this.state.searchTerm}
                onChange={(e) => this.onChange(e)}
                //className={classes.searchBox}
                placeholder={translate ? `${translate('tooltip_search')}....` : 'Search....'}
                // InputProps={{
                //   startAdornment: <InputAdornment position="start"><Icon>search</Icon></InputAdornment>,
                // }}
              />
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    )
  }
}

export default withStyles(styles)(SearchBar)
